import React from "react";
import { Error404ApiScreenContainer } from "src/containers";

export const Error404ApiScreen = () => {
  return <Error404ApiScreenContainer />;
};
